/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".float-container[_ngcontent-%COMP%]{padding:20px 20px 30px;width:400px}.wizard-content-wrap-columns[_ngcontent-%COMP%]{gap:15px}.action-item[_ngcontent-%COMP%]{display:flex;align-items:center;gap:6px;padding:10px 10px 0 40px}.topo-icon[_ngcontent-%COMP%]{margin-left:4px}\n/*# sourceMappingURL=line-geom-edit-wizard.component.css.map*/"];
export { styles as styles };
